import { useTranslation } from 'react-i18next';

export const LabelAndURL = ({ label, href, website }: { label: string; href: string; website: string }) => {
  const { t } = useTranslation();
  return (
    <>
      {t(label)}{' '}
      <a href={href} target="_blank" rel="noopener">
        {website}
      </a>
    </>
  );
};
